/* eslint-disable */
import { IModelResponse, IModel } from '@cian/http-api';
import { IAllOfferDataSchema } from '../../entities/all_offer_data/AllOfferDataSchema';
import { IErrorResponseSchema } from '../../../../../shared/repositories/offer-card/entities/schemas/ErrorResponseSchema';

export interface IGetOfferDataRequest {
  /** Идентификатор оффера **/
  offerId: number;
  /** Тип сделки **/
  dealType: EDealType;
  /** Тип оффера **/
  offerType: EOfferType;
  /** Поддомен **/
  subdomain: string;
  /** Realty id юзера **/
  realtyUserId?: number;
  /** Анонимный id юзера(из куки_CIAN_GK) **/
  anonymousUserId?: string;
  /** Часовой пояс (смещение относительно UTC) **/
  tzOffset?: number;
}
export enum EDealType {
  'Rent' = 'rent',
  'Sale' = 'sale',
}
export enum EOfferType {
  'Commercial' = 'commercial',
  'Flat' = 'flat',
  'Newobject' = 'newobject',
  'Suburban' = 'suburban',
}
export interface IGetOfferDataResponse200 extends IModelResponse<IAllOfferDataSchema> {
  statusCode: 200;
}
export interface IGetOfferDataResponse400 extends IModelResponse<IErrorResponseSchema> {
  statusCode: 400;
}
export type IGetOfferDataResponse = IAllOfferDataSchema;

export type IGetOfferDataResponseError = IErrorResponseSchema;

export type TGetOfferDataResponse = IGetOfferDataResponse200 | IGetOfferDataResponse400;

export type TGetOfferDataModel = IModel<IGetOfferDataRequest, TGetOfferDataResponse>;
export interface IMappers<TResponse200, TResponse400> {
  200(response: IAllOfferDataSchema): TResponse200;
  400(response: IErrorResponseSchema): TResponse400;
}
